import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_PARTNER_GET_BY_ID } from 'api/actionTypes';

export default async function getById({ state, apiClient }, { partnerId, forceRefresh = false }) {
  typeCheck('partnerId::PositiveNumber', partnerId);

  const currentPartnerStatePath = ['partners', 'byId', partnerId];
  if (state.get(currentPartnerStatePath) && !forceRefresh) {
    return state.get(currentPartnerStatePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_BY_ID,
    queryId: partnerId,
    state: state,
    payload: {
      partnerId,
    },
    onSuccess(partner) {
      if (partner) {
        state.set(currentPartnerStatePath, partner);
      }
    },
  });
}
